/** Company Enrich strings (extracted to keep en.ts under the size ratchet). */
export const enCompanyEnrich = {
	to: "to",
	workforceGrowthFilters: "Workforce Growth",
	workforceGrowthFiltersDescription:
		"Filter by workforce growth percentage over a selected period and department",
	workforcePeriodLabel: "Workforce Growth Period",
	workforceDepartmentLabel: "Department",
	workforceGrowthLabel: "Workforce Growth (%)",
	workforceGrowthMinPlaceholder: "Min %",
	workforceGrowthMaxPlaceholder: "Max %",
	personFilters: "Person Filters",
	excludePersonaCategoryLabel: "Exclude Persona Categories",
	excludePersonaCategoryPlaceholder: "Select persona categories to exclude",
	excludeIndustriesLabel: "Exclude industries",
	excludeIndustriesPlaceholder: "Select industries to exclude",
	personaCategoryLabel: "Persona category",
	personaCategoryPlaceholder: "Select persona categories",
	companyFilters: "Company Details",
	companyFiltersDescriptionTracker:
		"Filter by company type, category, size, and revenue, and founded years",
	companyFiltersDescription:
		"Filter by industry, size, revenue, type, category, founded year and technologies",
	fundingFilters: "Funding Data",
	fundingFiltersDescription: "Filter by funding rounds, amount, and years",
	locationFilters: "Company Location",
	locationFiltersDescription: "Filter by region, country, state, and city",
	locationFiltersDescriptionTracker: "Filter by region, and country",
	addSource: "Add Source",
	sourceNameLabel: "Source Name",
	namePlaceholder: "Enter source name",
	positionQueryLabel: "Position / Job Title",
	positionQueryPlaceholder: "e.g. CEO, CTO, Sales Manager",
	excludePositionQueryLabel: "Exclude Positions",
	excludePositionQueryPlaceholder: "e.g. Intern, Assistant",
	seniorityLabel: "Seniority",
	seniorityPlaceholder: "Select seniority levels",
	departmentLabel: "Department",
	departmentPlaceholder: "Select departments",
	countriesLabel: "Personal Location (Countries)",
	countriesPlaceholder: "Select countries",
	universitiesLabel: "Universities",
	universitiesPlaceholder: "e.g. Harvard University",
	domainsLabel: "Domains",
	domainsPlaceholder: "e.g. example.com",
	industriesLabel: "Industries",
	industriesPlaceholder: "Select industries",
	employeesLabel: "Employees",
	employeesPlaceholder: "Select employee ranges",
	revenueLabel: "Revenue",
	revenuePlaceholder: "Select revenue ranges",
	keywordsLabel: "Keywords",
	keywordsDescription: "Add custom keywords for filtering",
	keywordsPlaceholder: "Search keywords",
	technologiesLabel: "Technologies",
	technologiesPlaceholder: "Search technologies",
	similarDomainsLabel: "Similar Domains",
	similarDomainsPlaceholder: "e.g. example.com",
	queryLabel: "Personal Name",
	before: "Before",
	after: "After",
	queryPlaceholder: "e.g. John Smith",
	excludeCountriesLabel: "Exclude Countries",
	excludeCountriesPlaceholder: "Select countries to exclude",
	excludeDomainsLabel: "Exclude Domains",
	excludeDomainsPlaceholder: "e.g. example.com",
	excludeSeniorityLabel: "Exclude Seniority",
	excludeSeniorityPlaceholder: "Select seniority levels to exclude",
	excludeDepartmentLabel: "Exclude Departments",
	excludeDepartmentPlaceholder: "Select departments to exclude",
	atCurrentCompanyLabel: "Tenure at Current Company",
	atCurrentCompanyAfterPlaceholder: "Joined after",
	atCurrentCompanyBeforePlaceholder: "Joined before",
	atCurrentPositionLabel: "Tenure at Current Position",
	atCurrentPositionAfterPlaceholder: "Started after",
	atCurrentPositionBeforePlaceholder: "Started before",
	previewCount: "Estimated results: {{count}}",
	noResults: "No results found.",
	showMore: "Show more...",
	showLess: "Show less...",
	previewName: "Name",
	previewCompany: "Company",
	previewPosition: "Position",
	previewSeniority: "Seniority",
	searchForCompanies: "Search for companies",
	companyName: "Company name",
	companyNamePlaceholder: "Search by company name",
	addCompanyManually: "Add company manually",
	previewDepartment: "Department",
	companyCountriesLabel: "Company Countries",
	companyCountriesPlaceholder: "Select company countries",
	companyStatesLabel: "Company States",
	companyStatesPlaceholder: "Search states",
	companyCitiesLabel: "Company Cities",
	companyCitiesPlaceholder: "Search cities",
	companyTypeLabel: "Company Type",
	companyTypePlaceholder: "Select company types",
	companyCategoryLabel: "Company category",
	companyCategoryPlaceholder: "Select company categories",
	categoryLabel: "Category",
	search: "Search",
	results: "Results",
	selected: "Selected",
	categoryPlaceholder: "Select categories",
	companySizeLabel: "Company size",
	companySizePlaceholder: "Select company sizes",
	categoryOperatorLabel: "Category Operator",
	keywordsOperatorLabel: "Keywords Operator",
	technologiesOperatorLabel: "Technologies Operator",
	fundingRoundsLabel: "Funding Rounds",
	fundingRoundsPlaceholder: "Select funding rounds",
	fundingAmountLabel: "Funding Amount",
	fundingAmountMinPlaceholder: "Min amount",
	fundingAmountMaxPlaceholder: "Max amount",
	fundingYearLabel: "Funding Year",
	fundingYearMinPlaceholder: "Min year",
	fundingYearMaxPlaceholder: "Max year",
	foundedYearLabel: "Founded Year",
	foundedYearMinPlaceholder: "Min year",
	foundedYearMaxPlaceholder: "Max year",
	requireLabel: "Require",
	requirePlaceholder: "Select required features",
	regionsLabel: "Regions",
	regionsPlaceholder: "Select regions",
	semanticQueryLabel: "Semantic Search",
	semanticQueryPlaceholder: "Describe what you are looking for",
	similarityWeightLabel: "Similarity Weight",
	similarityWeightPlaceholder: "e.g. 0.7",
	invalidLinkedinUrl: "Invalid LinkedIn URL",

	// By LinkedIn URL tab
	byUrlNameSearchLabel: "Search LinkedIn by name",
	byUrlNameSearchPlaceholder: "e.g. John Smith",
	byUrlNameSearchHelper: "Searches LinkedIn directly — select people from the results.",
	byUrlOr: "or",
	byUrlPasteLabel: "Paste LinkedIn profile URLs",
	byUrlPastePlaceholder: "Paste a URL and press Enter",
	byUrlPasteHelper: "Add one lead after another (paste → Enter)",
	byUrlCapExceeded: "Max {{max}} URLs at once. {{count}} more were not added.",
	byUrlInvalidPresent: "Remove the invalid LinkedIn URLs before adding.",
	byUrlRemoveChip: "Remove",
	byUrlNameDisabledNote: "You're adding profile URLs.",
	byUrlSwitchToName: "Clear & search by name instead",
	byUrlUrlDisabledNote: "You're searching by name.",
	byUrlSwitchToUrl: "Clear & paste URLs instead",
	byUrlProfileReady: "profile ready to add",
	byUrlProfilesReady: "profiles ready to add",
	byUrlReadyDescription: "Choose a list below to add the pasted profiles.",
	byUrlResolvedHeader: "From LinkedIn URLs",
	byUrlResolving: "Searching for the profile…",
	byUrlResolveFailed: "Couldn't find this profile",
	byUrlExistingHeader: "Existing contacts",
	byUrlEmptyTitle: "Search a name or paste profile URLs",
	byUrlEmptyDescription: "Find people on LinkedIn by name, or drop in profile URLs to add them.",

	advancedSearch: "Advanced Search",
	noPeopleFound: "No people found",
	addLead: "Add Lead",
	companyDomainsLabel: "Company domains",
	byCriteria: "By criteria",
	byLinkedinUrl: "By LinkedIn URL",
	adjustFilters: "Try adjusting your filters",
	advancedSearchDescription:
		"Search by semantic query or find companies similar to specific domains",
	// Category options
	categoryB2b: "B2B",
	categoryB2c: "B2C",
	categoryB2g: "B2G",
	categoryEcommerce: "E-Commerce",
	categoryMedia: "Media",
	categoryServiceProvider: "Service Provider",
	categoryMobile: "Mobile",
	categorySaas: "SaaS",

	// Funding round options
	fundingRoundSeed: "Seed",
	fundingRoundDebtFinancing: "Debt Financing",
	fundingRoundAngel: "Angel",
	fundingRoundVenture: "Venture",
	fundingRoundSeriesA: "Series A",
	fundingRoundSeriesB: "Series B",
	fundingRoundSeriesC: "Series C",
	fundingRoundSeriesD: "Series D",
	fundingRoundSeriesE: "Series E",
	fundingRoundSeriesF: "Series F",
	fundingRoundSeriesG: "Series G",
	fundingRoundSeriesH: "Series H",
	fundingRoundOther: "Other",

	// Company type options
	companyTypePrivate: "Private",
	companyTypePublic: "Public",
	companyTypeSelfEmployed: "Self-employed",
	companyTypeSelfOwned: "Self-owned",
	companyTypePartnership: "Partnership",
	companyTypeNonProfit: "Non-profit",
	companyTypeEducational: "Educational",
	companyTypeGovernment: "Government",

	// Revenue options
	revenueUnder1m: "Under $1M",
	revenue1mTo10m: "$1M–$10M",
	revenue10mTo50m: "$10M–$50M",
	revenue50mTo100m: "$50M–$100M",
	revenue100mTo200m: "$100M–$200M",
	revenue200mTo1b: "$200M–$1B",
	revenueOver1b: "Over $1B",

	// Use-case modes
	modeSearch: "Classic search",
	modeLookalike: "Lookalike search",
	modeNewInRole: "New in role",
	modeDescription_SEARCH:
		"Filter the lead database directly. Set company and people criteria — every filter can match or exclude — to assemble your list.",
	modeDescription_LOOK_A_LIKE:
		"Start from companies you already know — give a few good-fit examples and we find others like them, then your filters narrow the set.",
	modeDescription_NEW_IN_ROLE:
		"Find people whose role or employer changed within your time window.",
	findSinglePersonHint: "Looking for just one person? Find them and enrich their email & phone.",
	findSinglePersonCta: "Find a single person",

	// Lookalike seed card
	lookalikeSeedTitle: "Lookalike companies",
	lookalikeSeedDescription:
		"Add a few reference company domains and we will find companies similar to them.",
	lookalikeSeedLabel: "Reference companies",

	// New in role
	newInRoleFindPeopleThat: "Find people that",
	newInRoleInTheLast: "In the last",
	newInRoleStartedNewRole: "Started a new role",
	newInRoleStartedNewRoleInfo:
		"Includes people who kept the same employer with a new title, as well as people who started at a new employer.",
	newInRoleStartedNewEmployer: "Started at a new employer",
	newInRoleWindow30: "30 days",
	newInRoleWindow90: "90 days",
	newInRoleWindow180: "6 months",
	newInRoleWindow365: "12 months",
	newInRoleWindowCustom: "Custom range",
	newInRoleFromDaysAgo: "From (days ago)",
	newInRoleToDaysAgo: "To (days ago)",
	newInRoleDaysAgoPlaceholder: "e.g. 90",

	// Lookalike extras
	lookalikeSearchInYourCompanies: "Search in your companies",
	lookalikePrefillPositiveReplies: "Last 10 positive replies",
	similarDomainsMax: "Maximum of {{count}} similar domains reached",

	// Exclude leads & companies
	excludeCompaniesCardTitle: "Exclude leads & companies",
	excludeCompaniesCardDescription:
		"Subtract leads and companies you don't want before this list is built",
	excludeLeadsBoxTitle: "Exclude leads",
	excludeCompaniesBoxTitle: "Exclude companies",
	excludeCompaniesToggle: "Exclude companies",
	excludeCompaniesDescription: "Subtract companies you don't want before this list is built.",
	excludeCompaniesScopeLabel: "Scope",
	excludeCompaniesScopePlaceholder: "No company scope excluded",
	excludeCompaniesScopeKnown: "All known companies",
	excludeCompaniesScopeLists: "Companies from selected lists",
	excludeCompaniesListsLabel: "Select lists to exclude",
	excludeCompaniesListsPlaceholder: "Search your lists",
	excludeCompaniesCompetitors: "Exclude my competitors",
	excludeCompaniesCompetitorsDescription: "Uses your tracked competitor list in Signalist",
	excludeCompaniesReviewCompetitors: "Review my competitors",
	excludeCompaniesDomains: "Exclude specific companies or domains",
	excludeCompaniesDomainsDescription: "Manually subtract individual domains not covered above",
	excludeCompaniesDomainsPlaceholder: "Add a domain to exclude",
	findPersonTitle: "Find person",
	findPersonSubtitle:
		"Search for a matching person at each selected company and fill in the missing contact. The first match is used automatically.",
	findPersonKeywordsLabel: "Keywords",
	findPersonKeywordsPlaceholder: "e.g. procurement, logistics",
	findPersonSubmit: "Find people",
	findPersonSuccess: "Find person started: {{queued}} queued, {{skipped}} skipped",
	findPersonError: "Failed to start Find person",
	searchDefaults: {
		loading: "Loading your search defaults…",
		fromLastSearch: "Pre-filled from your last search.",
		fromCompanyPreset: "Pre-filled from your company's search defaults.",
		resetToCompanyPreset: "Reset to company preset",
		sameAsCompanyLocation: "Same as company location",
		settings: {
			title: "Search defaults",
			description:
				"The filters a new Lead Database or Lookalike search, and Find leads in the Chrome extension, start with until a user has searched once. After that, each user starts from their own last search.",
			loading: "Loading the search defaults…",
			jobTitlesLabel: "Job titles",
			jobTitlesPlaceholder: "e.g. CEO, Head of Sales",
			seniorityLabel: "Seniority",
			seniorityPlaceholder: "Select seniority levels",
			departmentLabel: "Departments",
			departmentPlaceholder: "Select departments",
			personLocationLabel: "Person location",
			companyLocationLabel: "Company location",
			countriesPlaceholder: "Select countries",
			employeesLabel: "Company size (employees)",
			employeesPlaceholder: "Select company sizes",
			industriesLabel: "Industries",
			industriesPlaceholder: "Select industries",
			save: "Save",
			saved: "Search defaults saved.",
			saveFailed: "The search defaults could not be saved.",
			regenerate: "Regenerate from ICP & Lead Scoring",
			regenerateHint:
				"Replaces the filters above with a new suggestion from your ICP and Lead Scoring. This can take up to a minute.",
			regenerated: "Search defaults regenerated from your ICP and Lead Scoring.",
			regenerateFailed: "The search defaults could not be regenerated.",
		},
	},
	searchError: "The search failed. Please try again.",
	noLinkedinError: "This person has no LinkedIn profile, so they cannot be added.",
	saveError: "The lead could not be added. Please try again.",
};
